import { Controller, useFormContext } from "react-hook-form";
import { RegisterOptions } from "react-hook-form";
import { BaseFormControl } from "./abstractions/base-form-control";
import MoneyInput from "components/elements/MoneyInput";
import React from "react";
import { useCustomFormats } from "hooks/useCustomFormat";

interface FormCurrencyProps {
  name: string;
  label: string;
  placeholder?: string;
  rules?: RegisterOptions;
  isReadOnly?: boolean;
  allowNegativeValue?: boolean;
}

export const FormCurrency = React.forwardRef<HTMLInputElement, FormCurrencyProps>(
  ({ name, label, placeholder, rules, isReadOnly, allowNegativeValue = false }, ref) => {
    const { control, setValue } = useFormContext();
    const { formatCurrency } = useCustomFormats();

    return (
      <BaseFormControl
        name={name}
        label={label}
        isRequired={!!rules?.required}
        isDisabled={!!rules?.disabled}
        isReadOnly={isReadOnly}
      >
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <MoneyInput
              allowNegativeValue={allowNegativeValue}
              placeholder={placeholder ?? formatCurrency(0)}
              {...field}
              ref={ref}
              value={field?.value ?? undefined}
              onChange={e => {}}
              onValueChange={value => {
                setValue(name, value);
              }}
            />
          )}
        />
      </BaseFormControl>
    );
  }
);

FormCurrency.displayName = "FormCurrency";
